import { connectToStores } from 'fluxible-addons-react';
import React from 'react';

import { Button } from '@99designs/common/components/Button';
import { ButtonGroup, ButtonGroupItem } from '@99designs/common/components/ButtonGroup';

import { suggestionsForDesign } from 'contest/apps/design-details/rating-suggestion-text';
import { ContestStageValues as ContestStage } from 'contest/models/contest';
import ContestStore from 'contest/stores/contest-store';
import { Design } from './../../../../contest/apps/design-details/models/design';
import CommentSuggestionsInfoButton from './comment-suggestions-info-button';

interface RatingSuggestionsProps {
    design: Design;
    stage: ContestStage;
    onSuggestionSelected: (text: string) => void;
}

export class RatingSuggestions extends React.Component<RatingSuggestionsProps> {
    render() {
        const { design, stage, onSuggestionSelected } = this.props;
        const suggestions = suggestionsForDesign(design, { stage });

        return (
            <div style={{ marginTop: '30px' }}>
                <ButtonGroup variations={['stacked']}>
                    {suggestions.map((text, i) => {
                        return (
                            <ButtonGroupItem key={i}>
                                <Button
                                    key="suggestion"
                                    variations={['secondary', 'fluid', 'text-suggestion']}
                                    onClick={() => onSuggestionSelected(text)}
                                >
                                    {text}
                                </Button>
                            </ButtonGroupItem>
                        );
                    })}
                    <ButtonGroupItem key="info">
                        <CommentSuggestionsInfoButton />
                    </ButtonGroupItem>
                </ButtonGroup>
            </div>
        );
    }
}

export default connectToStores(RatingSuggestions, [ContestStore], (ctx, _props) => {
    return {
        stage: ctx.getStore(ContestStore).getStage(),
    };
});



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/components/rating-suggestions.tsx